const nationwideConfig = Object.freeze({
    LABEL: 'Nationwide Provide',
    SHORT_LABEL: 'Nationwide',
    NAME: 'nationwide',
    PALETTE: {
        PRIMARY: '#0047BB',
        SECONDARY: '#1F74DB'
    },
    CONTACT_SUPPORT: {
        EMAIL: 'nationwideprovidesupport@joinansel.com',
        NUMBER: '(888) 488-1217',
        WEB_SITE: 'https://www.joinansel.com'
    },
    S3: {
        BASE_URL: 'https://joinansel-platform-assets.s3.amazonaws.com',
        SP_NAME: 'nationwide',
        APPLICATION: 'enrollment',
    },
    LEGAL:{
        SERVICE_NAME: 'Ansel Services, Inc.',
        INSURANCE_NAME: 'Ansel Health, Inc.',
        TERMS: 'https://www.joinansel.com/terms',
        PRIVACY: 'https://www.joinansel.com/privacy-policy'
    },
});

export default nationwideConfig;